import cn from 'classnames';
import { Button, Icon, TextLink, Typography } from '../../components';
import styles from './ImpersonationBanner.module.css';

export const ImpersonationBanner = ({
  name,
  exit,
  isImpersonatorUserAdmin = false,
  onOpenPatientNote,
}: {
  name: string;
  exit: () => void;
  /** Only meaningful where a non-admin can impersonate (results-portal). */
  isImpersonatorUserAdmin?: boolean;
  onOpenPatientNote?: () => void;
}) => {
  return (
    <div className={styles.bannerContainer}>
      {/* don't remove id='impersonate-banner' it is used for styling */}
      <div
        id='impersonate-banner'
        className={cn(
          styles.container,
          isImpersonatorUserAdmin && styles.admin,
        )}
      >
        <div className={styles.content}>
          <div className={styles.infoRow}>
            <div className={styles.iconContainer}>
              <Icon name='eye' />
            </div>
            <Typography
              variant='body-s'
              medium
              className={styles.impersonationText}
            >
              Viewing: <strong>{name}</strong>
            </Typography>
          </div>
          <div className={styles.actions}>
            {onOpenPatientNote && (
              <TextLink
                label='+ Patient Note'
                onClick={onOpenPatientNote}
                size='body-s'
                color='purple'
              />
            )}
            <Button
              type='button'
              label='Exit'
              onClick={() => exit()}
              className={styles.exitButton}
              color={isImpersonatorUserAdmin ? 'orange' : 'blue'}
              size='small'
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ImpersonationBanner;
